import { ArticleCompositionVO, ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArrayUtils } from '@shared/util/array-utils';

export class ArticleCompositionUtils {
  public static findArticleUsageById(composition: ArticleCompositionVO, articleUsageId: string): ArticleUsageVO | undefined {
    return composition.articleUsages.find(usage => usage.id === articleUsageId);
  }

  public static removeUnusedArticleUsageFromComposition(articleComposition: ArticleCompositionVO, articleUsage: ArticleUsageVO): void {
    if(ArrayUtils.removeItem(articleUsage, articleComposition.articleUsages)) {
      ArticleUsageUtils.removeAssociationsWithUsages(articleComposition.articleUsages, articleUsage.id);
    }
  }

  public static removeUnusedArticleUsageFromCompositionByIdAndVersion(articleComposition: ArticleCompositionVO, articleId: number, articleVersion: number): void {
    for (const articleUsage of articleComposition.articleUsages.concat()) {
      if (articleId === articleUsage.articleId && articleVersion === articleUsage.articleVersion) {
        this.removeUnusedArticleUsageFromComposition(articleComposition, articleUsage);
      }
    }
  }

  public static articleUsageIds(composition: ArticleCompositionVO) {
    return composition.articleUsages.map(articleUsage => articleUsage.id);
  }

  public static metaElementUsages(composition: ArticleCompositionVO) {
    return composition.articleUsages.flatMap(articleUsage => articleUsage.metaElementUsages);
  }
}
